var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      style: { pointerEvents: _vm.victory || _vm.defeat ? "none" : "auto" },
      attrs: {
        "data-namespace": "minesweeper",
        "data-style-mode": _vm.isMobile ? "mobile" : "pc"
      },
      on: { touchmove: _vm.onTouchmove, mousemove: _vm.onTouchmove }
    },
    _vm._l(_vm.grids, function(row, y) {
      return _c(
        "div",
        { key: y, staticClass: "row" },
        _vm._l(row, function(grid, x) {
          return _c(
            "div",
            {
              key: x,
              staticClass: "grid",
              style: _vm.gridStyle,
              on: {
                mousedown: function($event) {
                  !_vm.isMobile && _vm.onGridMousedown(x, y, $event)
                },
                mouseup: function($event) {
                  !_vm.isMobile && _vm.onGridMouseup(x, y, $event)
                },
                touchstart: function($event) {
                  _vm.isMobile && _vm.onGridMousedown(x, y, $event)
                },
                touchend: function($event) {
                  _vm.isMobile && _vm.onGridMouseup(x, y, $event)
                },
                click: [
                  function($event) {
                    _vm.isMobile && _vm.onGridClick(x, y)
                  },
                  function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "left", 37, $event.key, [
                        "Left",
                        "ArrowLeft"
                      ])
                    ) {
                      return null
                    }
                    if ("button" in $event && $event.button !== 0) {
                      return null
                    }
                    !_vm.isMobile && _vm.onLeftClick(x, y)
                  }
                ],
                contextmenu: function($event) {
                  !_vm.isMobile && _vm.onRightClick(x, y, $event)
                }
              }
            },
            [
              !grid.exposed
                ? [
                    grid.exploring && !grid.marked
                      ? _c("div", { staticClass: "explore" })
                      : _c("div", {
                          staticClass: "cover",
                          class: { marked: grid.marked }
                        })
                  ]
                : _vm._e(),
              _vm._v(" "),
              grid.exposed || _vm.debug
                ? [
                    grid.isMine
                      ? _c("div", {
                          staticClass: "mine",
                          class: { debug: _vm.debug && !grid.exposed }
                        })
                      : grid.minesCount > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "num",
                              class: ((_obj = {
                                debug: _vm.debug && !grid.exposed
                              }),
                              (_obj["color" + grid.minesCount] = true),
                              _obj)
                            },
                            [_vm._v(_vm._s(grid.minesCount))]
                          )
                        : _c("div", {
                            staticClass: "empty",
                            class: { debug: _vm.debug && !grid.exposed }
                          })
                  ]
                : _vm._e()
            ],
            2
          )
          var _obj
        })
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }